type CrmProvider = 'hubspot' | 'brevo'

/**
 * The Brevo and HubSpot marks, inline. Copied from the Form Spam prototype
 * (`form-settings-shared.tsx:579`), where they were `<img src="/form-spam/*.svg">`
 * first and moved into the bundle because the dev server queued every
 * `public/` request behind a rebuild (1.59s measured) and the tiles sat
 * empty. Both are one path under 700 bytes.
 *
 * The DS `IntegrationLogo` covers the ad platforms only, so it cannot draw
 * these. DS gap, reported with the Form Spam lane.
 *
 * `aria-hidden`: every place that draws a mark prints the name beside it.
 */
export const BrevoMark = ({
	className = 'h-7 w-7'
}: {
	className?: string
}) => (
	<svg
		viewBox="0 0 24 24"
		className={className}
		fill="#0B996E"
		aria-hidden="true"
		focusable="false"
	>
		<path d="M12 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0zM7.2 4.8h5.747c2.34 0 3.895 1.406 3.895 3.516 0 1.022-.348 1.862-1.09 2.588C17.189 11.812 18 13.22 18 14.785c0 2.86-2.64 5.016-6.164 5.016H7.199v-15zm2.085 1.952v5.537h.07c.233-.432.858-.796 2.249-1.226 2.039-.659 3.037-1.52 3.037-2.655 0-.998-.766-1.656-1.924-1.656H9.285zm4.87 5.266c-.766.385-1.67.748-2.76 1.11-1.229.387-2.11 1.386-2.11 2.407v2.315h2.365c2.387 0 4.149-1.34 4.149-3.155 0-1.067-.625-2.087-1.645-2.677z" />
	</svg>
)

export const HubSpotMark = ({
	className = 'h-7 w-7'
}: {
	className?: string
}) => (
	<svg
		viewBox="0 0 24 24"
		className={className}
		fill="#FF7A59"
		aria-hidden="true"
		focusable="false"
	>
		<path d="M18.164 7.93V5.084a2.198 2.198 0 001.267-1.978v-.067A2.2 2.2 0 0017.238.845h-.067a2.2 2.2 0 00-2.193 2.193v.067a2.196 2.196 0 001.252 1.973l.013.006v2.852a6.22 6.22 0 00-2.969 1.31l.012-.01-7.828-6.095A2.497 2.497 0 104.3 4.656l-.012.006 7.697 5.991a6.176 6.176 0 00-1.038 3.446c0 1.343.425 2.588 1.147 3.607l-.013-.02-2.342 2.343a1.968 1.968 0 00-.58-.095h-.002a2.033 2.033 0 102.033 2.033 1.978 1.978 0 00-.1-.595l.005.014 2.317-2.317a6.247 6.247 0 104.782-11.134l-.036-.005zm-.964 9.378a3.206 3.206 0 113.215-3.207v.002a3.206 3.206 0 01-3.207 3.207z" />
	</svg>
)

/** The mark for a provider, at the size the caller asks for. */
export const CrmMark = ({
	provider,
	className
}: {
	provider: CrmProvider
	className?: string
}) =>
	provider === 'brevo' ? (
		<BrevoMark className={className} />
	) : (
		<HubSpotMark className={className} />
	)

/**
 * The 24px mark the table row and the sheet card lead with, the same size
 * the Credentials tab gives `IntegrationLogo`, so the two tables share one
 * left edge and one glyph size.
 */
export const CrmIcon = ({ provider }: { provider: CrmProvider }) => (
	<CrmMark provider={provider} className="h-6 w-6 shrink-0" />
)
